// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { IdentityGet } from '../../../../types/server/modules/identity/get';

export type * from '../../../../types/server/modules/identity/get';

export const createGet = ( requests: Requests ): IdentityGet => ({
  sign_in_with_google: ( params,headers ) => {
      return requests.get( `/auth/sign-in-with-google`, params, headers );
    },
  sign_in_with_mercadolibre: ( params,headers ) => {
      return requests.get( `/auth/sign-in-with-mercadolibre`, params, headers );
    },
  auth_callback: ( params,headers ) => {
      return requests.get( `/api/auth/callback/:provider`, params, headers );
    },
  oauth2_callback: ( params,headers ) => {
      return requests.get( `/api/auth/oauth2/callback/:provider`, params, headers );
    },
  get_feature_flags: ( headers ) => {
      return requests.get( `/authorization/flags`, undefined, headers );
    },
  get_capability_registry: ( headers ) => {
      return requests.get( `/authorization/capability-registry`, undefined, headers );
    },
  get_system_roles: ( headers ) => {
      return requests.get( `/authorization/system-roles`, undefined, headers );
    }
});
